import backQuienesSomosUrl from "../img/back-quienes-somos.webp";
import backQuienesSomos1440Url from "../img/back-quienes-somos-1440.webp";
import backQuienesSomos1024Url from "../img/back-quienes-somos-1024.webp";
import backQuienesSomos768Url from "../img/back-quienes-somos-768.webp";
import backHomeUrl from "../img/back-home.webp";
import backHome1440Url from "../img/back-home-1440.webp";
import backHome1024Url from "../img/back-home-1024.webp";
import backHome768Url from "../img/back-home-768.webp";
import barcelonaUrl from "../img/barcelona.webp";
import barcelona1024Url from "../img/barcelona-1024.webp";
import barcelonaPngUrl from "../img/barcelona.png";
import barcelonatxtUrl from "../img/barcelonatxt.jpg";
import madridUrl from "../img/madrid.webp";
import madrid1024Url from "../img/madrid-1024.webp";
import madridPngUrl from "../img/madrid.png";
import madridtxtUrl from "../img/madridtxt.jpg";
import homeVideoUrl from "../img/home.mp4";
import albertCastellanosUrl from "../img/albert-castellanos.jpg";
import albertCastellanosWebpUrl from "../img/albert-castellanos.webp";
import signaturaUrl from "../img/signatura.png";
import signaturaWebpUrl from "../img/signatura.webp";
import bcnymdrUrl from "../img/bcnymdr.png";
import { closeSiteMenu } from "./site-menu.js";
import { withBase, stripBase, SERVICES } from "./services.js";
import { runTransition } from "./page-demo.js";
import {
  DEFAULT_LOCALE,
  LOCALES,
  CANONICAL_SLUGS,
  parseLocalePath,
  localePath,
} from "../i18n/index.js";
import {
  ROUTE_CATALOG,
} from "./route-catalog.js";

const SERVICE_MAP = new Map(SERVICES.map((s) => [s.path, s]));

function serviceBody(canonicalPath, extraClass = "") {
  const s = SERVICE_MAP.get(canonicalPath);
  return {
    className: `page detail-page detail-page--service${extraClass ? ` ${extraClass}` : ""}`,
    dataset: { detailPage: "" },
    style: `--detail-accent: var(${s.accentVar}); --detail-image: url('${s.imageUrl}'); --detail-image-1440: url('${s.imageUrl1440}'); --detail-image-1024: url('${s.imageUrl1024}'); --detail-image-768: url('${s.imageUrl768}');`
  };
}

const TRANSITION_HIDE_DELAY_MS = 140;
const SERVICE_TITLE_DELAY_MS = 800;

function normalizePath(pathname) {
  if (!pathname) {
    return "/";
  }

  const raw = stripBase(pathname);
  const withoutQuery = raw.split("?")[0]?.split("#")[0] ?? raw;
  const trimmed = withoutQuery.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

function setBodyAttributes({ className, dataset = {}, style = "" }) {
  document.body.className = className;
  document.body.removeAttribute("data-detail-page");

  Object.keys(document.body.dataset).forEach((key) => {
    if (key.startsWith("detail") || key.startsWith("info")) {
      delete document.body.dataset[key];
    }
  });

  Object.entries(dataset).forEach(([key, value]) => {
    if (value === false || value === undefined || value === null) {
      return;
    }
    document.body.dataset[key] = value === true ? "" : String(value);
  });

  if (style) {
    document.body.setAttribute("style", style);
  } else {
    document.body.removeAttribute("style");
  }
}

function setDocumentMeta({ title, canonicalPathname, ogTitle, ogDescription, locale, routeCanonical }) {
  if (title) {
    document.title = title;
  }

  if (locale) {
    document.documentElement.lang = locale;
  }

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical instanceof HTMLLinkElement && canonicalPathname) {
    canonical.href = new URL(withBase(canonicalPathname), window.location.origin).toString();
  }

  if (ogTitle) {
    let ogTitleMeta = document.querySelector('meta[property="og:title"]');
    if (!ogTitleMeta) {
      ogTitleMeta = document.createElement('meta');
      ogTitleMeta.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitleMeta);
    }
    ogTitleMeta.content = ogTitle;
  }

  if (ogDescription) {
    let ogDescMeta = document.querySelector('meta[property="og:description"]');
    if (!ogDescMeta) {
      ogDescMeta = document.createElement('meta');
      ogDescMeta.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescMeta);
    }
    ogDescMeta.content = ogDescription;
  }

  if (routeCanonical) {
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => l.remove());
    for (const loc of LOCALES) {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = loc;
      link.href = new URL(withBase(localePath(loc, routeCanonical)), window.location.origin).toString();
      document.head.appendChild(link);
    }
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = new URL(withBase(localePath(DEFAULT_LOCALE, routeCanonical)), window.location.origin).toString();
    document.head.appendChild(xDefault);
  }
}

function renderIntoApp(html) {
  const container = document.querySelector("[data-spa-root]");
  if (!container) {
    throw new Error("No se encontró el contenedor SPA.");
  }

  container.innerHTML = html;
}

function legalPage(locale, { title, canonicalPath, body }) {
  const links = {
    es: [
      { canonical: "/aviso-legal", label: "aviso legal" },
      { canonical: "/politica-de-privacidad", label: "política de privacidad" },
      { canonical: "/politica-de-cookies", label: "política de cookies" },
    ],
    en: [
      { canonical: "/aviso-legal", label: "legal notice" },
      { canonical: "/politica-de-privacidad", label: "privacy policy" },
      { canonical: "/politica-de-cookies", label: "cookie policy" },
    ],
  };
  const ariaLabel = locale === "en" ? "Other policies" : "Otras políticas";
  const others = links[locale].filter((l) => l.canonical !== canonicalPath);
  const nav = others
    .map((l) => `<a href="${withBase(localePath(locale, l.canonical))}">${l.label}</a>`)
    .join('<span aria-hidden="true"> · </span>');
  return `
    <main class="legal-page">
      <div class="legal-page__inner">
        <h1 class="legal-page__title">${title}</h1>
        <div class="legal-page__body">${body}</div>
        <nav class="legal-page__links" aria-label="${ariaLabel}">${nav}</nav>
      </div>
    </main>
  `;
}

function detailPage(heroContent, pillTitle, sections) {
  const sectionHtml = sections.map((s) => `
    <section class="detail-pill__section">
      <h3 class="detail-pill__section-title">${s.h3}</h3>
      ${s.ul
        ? `<ul class="detail-pill__list">${s.ul.map((i) => `<li>${i}</li>`).join("")}</ul>`
        : `<p class="detail-pill__text">${s.p}</p>`}
      ${s.spacers ? new Array(s.spacers).fill("<p>&nbsp;</p>").join("") : ""}
    </section>
  `).join("");

  return `
    <main>
      <section class="detail-hero">
        <div class="detail-hero__image" aria-hidden="true"></div>
        <div class="detail-hero__veil" aria-hidden="true"></div>
        <div class="detail-hero__content">
          <h1 class="detail-hero__title">${heroContent}</h1>
        </div>
      </section>
      <section class="detail-body">
        <div class="detail-body__spacer" aria-hidden="true"></div>
        <div class="detail-reveal">
          <article class="detail-pill" data-scroll-reveal>
            <h2 class="detail-pill__title">${pillTitle}</h2>
            <div class="detail-pill__sections">${sectionHtml}</div>
          </article>
        </div>
      </section>
    </main>
  `;
}

function buildRouteDef(route, html) {
  if (!html) {
    throw new Error(`Missing route renderer for ${route.canonical}`);
  }

  const body = route.service
    ? serviceBody(route.canonical, route.extraClass)
    : route.body.kind === "team"
      ? {
          className: "page detail-page detail-page--team",
          dataset: { detailPage: "" },
          style: `--detail-accent: var(--accent-equipo); --detail-image: url('${backQuienesSomosUrl}'); --detail-image-1440: url('${backQuienesSomos1440Url}'); --detail-image-1024: url('${backQuienesSomos1024Url}'); --detail-image-768: url('${backQuienesSomos768Url}');`,
        }
      : route.body;

  return {
    canonical: route.canonical,
    service: route.service,
    body,
    meta: route.meta,
    html,
  };
}

const LEGAL_BODY_AVISO = `
  <h2>Información empresarial</h2>
  <p><strong>Empresa:</strong> GESTEGICA S.L.<br>
  <strong>CIF:</strong> B-62887906<br>
  <strong>Dirección:</strong> Calle Entença, 157, 1, Barcelona 08029<br>
  <strong>Registro Mercantil:</strong> Inscrita en Registro Mercantil de Barcelona, tomo 34855, folio 196, hoja B-252267</p>

  <h2>1. Concepto de usuario</h2>
  <p>La utilización de la web implica aceptación de todas las disposiciones del Aviso Legal y Políticas de Privacidad. Los usuarios deben revisar estos documentos en cada acceso, ya que pueden sufrir modificaciones.</p>

  <h2>2. Información sobre los links</h2>
  <p>&amp;COMUNICAS no es responsable de webs externas accesibles mediante vínculos. El uso de enlaces externos es responsabilidad exclusiva del usuario. La empresa no garantiza ni recomienda información obtenida mediante enlaces ajenos ni se responsabiliza de pérdidas derivadas de su uso.</p>

  <h2>3. Vínculos desde otras webs externas</h2>
  <p>Se prohíbe establecer enlaces desde páginas con contenido racista, xenófobo, pornográfico, que apologie el terrorismo o que viole derechos humanos. &amp;COMUNICAS no avala ni supervisa contenidos de páginas enlazadas sin autorización expresa.</p>

  <h2>4. Política de privacidad</h2>
  <p>Los datos facilitados mediante formularios serán tratados conforme a la normativa RGPD y leyes españolas de protección de datos. Los usuarios pueden solicitar portabilidad, acceso, rectificación, supresión, oposición y limitación de datos dirigiéndose a la dirección registrada.</p>

  <h2>5. Información sobre cookies</h2>
  <p>La web utiliza cookies para mejorar servicios. Consulte la Política de Cookies para detalles sobre su uso.</p>

  <h2>6. Renuncia y limitación de responsabilidad</h2>
  <p>&amp;COMUNICAS implementa medidas de seguridad pero se reserva derechos de rectificación. La información proviene de fuentes consideradas fiables pero sin garantía de exactitud o actualización.</p>

  <h2>7. Indicaciones sobre aspectos técnicos</h2>
  <p>&amp;COMUNICAS declina responsabilidad por interrupciones, malfuncionamientos, caídas de red, pérdida de información, suspensiones de fluido eléctrico u otros daños indirectos ajenos a la empresa. No garantiza servicios ininterrumpidos, libres de errores o virus.</p>

  <h2>8. Propiedad industrial e intelectual</h2>
  <p>Los contenidos están protegidos por legislación de propiedad intelectual. Se prohíbe reproducción, distribución, comunicación pública o transformación sin consentimiento expreso escrito. Los usuarios no pueden explotar comercialmente contenidos, imágenes, diseños, textos, gráficos, logotipos, software o marcas sin autorización previa.</p>
  <p>Se prohíbe establecer enlaces, frames o vínculos a las páginas sin consentimiento previo y expreso. Los usuarios que envíen observaciones por correo electrónico autorizan su reproducción, distribución y transformación de forma gratuita, sin derecho a remuneración.</p>
`;

const LEGAL_BODY_PRIVACIDAD = `
  <h2>1. Alcance</h2>
  <p>La presente Política de privacidad de GESTEGICA S.L. (denominada &amp;Comunicas) regula la obtención, utilización y procesamiento de datos personales facilitados por usuarios en la web o entornos de Internet de la entidad.</p>
  <p>Mediante formularios en los websites, los usuarios aceptan "la inclusión y tratamiento de los datos que proporcionen en un tratamiento de datos de carácter personal".</p>
  <p>Los textos legales pueden ser modificados según las necesidades y actividades de &amp;Comunicas.</p>

  <h2>¿Quién es responsable del tratamiento?</h2>
  <p>&amp;Comunicas es responsable de la recogida y procesamiento de datos personales relacionados con sus servicios.</p>
  <p><strong>Razón Social:</strong> GESTEGICA S.L.<br>
  <strong>CIF:</strong> B-62887906<br>
  <strong>Dirección:</strong> Calle Entença, 157, 1, Barcelona 08029<br>
  <strong>Contacto:</strong> <a href="mailto:protecciondatos@comunicas.es">protecciondatos@comunicas.es</a></p>

  <h2>¿Con qué finalidades se recopilan datos?</h2>
  <p>&amp;Comunicas recoge datos "estrictamente necesarios para ofrecer los servicios derivados de su actividad". Los datos de contacto se tratan para:</p>
  <ul>
    <li>Gestión de datos de contacto para solventar dudas o sugerencias (base legal: consentimiento)</li>
  </ul>
  <p>No se realizan evaluaciones automatizadas ni perfiles de usuarios. Los datos pueden usarse para identificación de usuarios y estudios estadísticos.</p>

  <h2>Duración de conservación</h2>
  <p>Los datos personales se conservan mientras el usuario no lo indique contrariamente y según plazos legales establecidos, salvo pérdida de utilidad.</p>

  <h2>Destinatarios de los datos</h2>
  <p>Los datos pueden comunicarse a terceros que proporcionan servicios de Tecnologías de la Información, proveedores de plataforma, alojamiento y mantenimiento.</p>
  <p>&amp;Comunicas no vende, alquila o cede los datos personales, excepto cuando sea necesario para la prestación del servicio.</p>

  <h2>Derechos de los usuarios</h2>
  <p>Los usuarios pueden ejercitar derechos bajo "el Reglamento (UE) 2016/679" y la Ley Orgánica 3/2018, incluyendo portabilidad, acceso, rectificación, supresión y limitación del tratamiento.</p>
  <p>Las solicitudes deben dirigirse a:<br>
  GESTEGICA S.L., Calle Entença, 157, 1, 08029 Barcelona<br>
  o <a href="mailto:protecciondatos@comunicas.es">protecciondatos@comunicas.es</a></p>
`;

const LEGAL_BODY_COOKIES = `
  <h2>¿Qué son las cookies?</h2>
  <p>Este sitio web utiliza cookies y tecnologías similares que almacenan y recuperan información durante la navegación. Estas tecnologías pueden servir para diversos propósitos, como reconocer al usuario, obtener información sobre hábitos de navegación o personalizar la presentación del contenido.</p>

  <h2>Tipos de cookies</h2>
  <p><strong>Cookies técnicas:</strong> Permiten la navegación por el sitio web, la utilización de servicios, control de tráfico, identificación de sesión, acceso a áreas restringidas, recordar elementos de pedidos, procesamiento de compras, inscripciones a eventos, elementos de seguridad, almacenamiento de contenidos multimedia y compartición en redes sociales.</p>
  <p><strong>Cookies de personalización o preferencias:</strong> Permiten acceder al servicio con características predefinidas según criterios del terminal del usuario, como idioma, tipo de navegador y configuración regional.</p>
  <p><strong>Cookies de análisis:</strong> Posibilitan el seguimiento del comportamiento de usuarios para medir la actividad del sitio web y elaborar perfiles de navegación, con el objetivo de introducir mejoras basadas en datos de uso.</p>

  <h2>Cookies utilizadas</h2>
  <p>El sitio utiliza Google Analytics para recopilar información anónima sobre visitantes y páginas populares.</p>

  <h2>Configuración de cookies por navegador</h2>
  <ul>
    <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-que-los-sitios-we" target="_blank" rel="noopener">Firefox</a></li>
    <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener">Google Chrome</a></li>
    <li><a href="http://support.apple.com/kb/HT1677" target="_blank" rel="noopener">Safari</a></li>
  </ul>
`;

const SERVICE_ROUTE_RENDERERS = {
  "/desarrollo-corporativo": {
    html: (locale) => locale === "en"
      ? detailPage(
          "CORPORATE DEVELOPMENT",
          "CORPORATE DEVELOPMENT AND STRATEGIC ALLIANCES",
          [
            { h3: "Mergers and Acquisitions (M&amp;A):", p: "We support companies throughout the entire corporate operations cycle, from identifying opportunities to post-acquisition integration, ensuring synergies and value creation." },
            { h3: "Strategic alliances and joint ventures:", p: "We design and structure agreements that enhance competitiveness, opening new avenues for growth and market access." },
            { h3: "Ecosystem development:", p: "We foster collaboration among companies, institutions, and key stakeholders to create environments that promote innovation and sustainable development." },
          ]
        )
      : detailPage(
          "DESARROLLO CORPORATIVO",
          "DESARROLLO CORPORATIVO<br />Y ALIANZAS ESTRATÉGICAS",
          [
            { h3: "Fusiones y Adquisiciones (M&amp;A):", p: "Acompañamos a la empresa en todo el ciclo de operaciones corporativas, desde la identificación de oportunidades hasta la integración post-adquisición, garantizando sinergias y creación de valor." },
            { h3: "Alianzas estratégicas y joint ventures:", p: "Diseñamos y estructuramos acuerdos que potencian la competitividad, abriendo nuevas vías de crecimiento y acceso a mercados." },
            { h3: "Desarrollo de ecosistemas:", p: "Impulsamos la colaboración entre empresas, instituciones y actores clave para generar entornos que favorezcan la innovación y el desarrollo sostenible." },
          ]
        ),
  },
  "/acceso-capital": {
    html: (locale) => locale === "en"
      ? detailPage(
          "CAPITAL ACCESS",
          "ACCESS TO CAPITAL AND FUNDRAISING STRATEGY",
          [
            { h3: "Strategic support during the fundraising processes:", p: "We define the optimal strategy to attract capital, aligning financial goals with the business vision, and support its implementation." },
            { h3: "Connection with key investors:", p: "We facilitate access to exclusive networks of institutional and private investment, maximizing funding opportunities." },
            { h3: "Fundraising and consolidating capital for private investment vehicles:", p: "We assist private investment vehicles in their search for investors." },
          ]
        )
      : detailPage(
          "ACCESO A CAPITAL",
          "ACCESO A CAPITAL Y ESTRATEGIA<br />DE CAPTACIÓN DE FONDOS",
          [
            { h3: "Apoyo estratégico durante el proceso de captación de fondos:", p: "Definimos la estrategia óptima para atraer capital, alineando objetivos financieros con la visión de negocio, y acompañamos en su implementación." },
            { h3: "Conexión con inversores clave:", p: "Facilitamos el acceso a redes exclusivas de inversión institucional y privada, maximizando las oportunidades de financiación." },
            { h3: "<strong>Captación y consolidación del capital para vehículos de inversión privada:</strong>", p: "Acompañamos a vehículos de inversión privada en el proceso de búsqueda de inversores." },
          ]
        ),
  },
  "/internacionalizacion": {
    html: (locale) => locale === "en"
      ? detailPage(
          "INTERNATIONALIZATION,<br />SOFT LANDING, AND ECONOMIC<br />DIPLOMACY",
          "INTERNATIONALIZATION, SOFT LANDING, AND ECONOMIC DIPLOMACY",
          [
            { h3: "Investment Attraction:", p: "We create strategies to attract foreign capital and promote the establishment of projects in new markets." },
            { h3: "International operations facilitation programs:", p: "We simplify cross-border processes, ensuring regulatory compliance and operational efficiency." },
            { h3: "Soft-landing and internationalization services:", p: "We offer comprehensive services for safe and effective entry into international markets, minimizing risks and accelerating results." },
          ]
        )
      : detailPage(
          "INTERNACIONALIZACIÓN,<br />SOFT-LANDING Y DIPLOMACIA<br />ECONÓMICA",
          "INTERNACIONALIZACIÓN,<br />SOFT-LANDING Y DIPLOMACIA ECONÓMICA",
          [
            { h3: "Captación de Inversiones:", p: "Creamos estrategias para captar capital extranjero y fomentar la implantación de proyectos en nuevos mercados." },
            { h3: "Programas de facilitación de operaciones internacionales:", p: "Simplificamos procesos transfronterizos, asegurando cumplimiento normativo y eficiencia operativa." },
            { h3: "Servicios de soft-landing e internacionalización:", p: "Ofrecemos servicios integrales para una entrada segura y efectiva en mercados internacionales, minimizando riesgos y acelerando resultados." },
          ]
        ),
  },
  "/innovacion": {
    html: (locale) => locale === "en"
      ? detailPage(
          "INNOVATION",
          "INNOVATION",
          [
            { h3: "Design and implementation of regulatory and experimental frameworks:", p: "We collaborate in creating regulatory spaces that allow testing innovative solutions, driving digital and technological transformation." },
            { h3: "Comparative analysis and design of public-private innovation strategies:", p: "We design collaborative models that integrate innovation and regulation, fostering competitiveness and sustainable development.", spacers: 7 },
          ]
        )
      : detailPage(
          "INNOVACIÓN",
          "INNOVACIÓN",
          [
            { h3: "Diseño e implementación de marcos regulatorios y experimentales:", p: "Colaboramos en la creación de espacios normativos que permiten probar soluciones innovadoras, impulsando la transformación digital y tecnológica." },
            { h3: "Análisis comparativo y diseño de estrategias de innovación público-privadas:", p: "Diseñamos modelos colaborativos que integran innovación y regulación, fomentando la competitividad y el desarrollo sostenible.", spacers: 7 },
          ]
        ),
  },
  "/posicionamiento-estrategico": {
    html: (locale) => locale === "en"
      ? detailPage(
          "STRATEGIC POSITIONING",
          "STRATEGIC POSITIONING AND STAKEHOLDER MANAGEMENT STRATEGY",
          [
            { h3: "Institutional positioning and narrative design:", p: "We build clear and coherent messages that reinforce corporate identity and market perception." },
            { h3: "Stakeholder identification and management:", p: "We identify key actors and develop strategies to establish strong and trustworthy relationships." },
            { h3: "Case study development and goal-oriented strategic communication:", p: "We produce case studies aligned with objectives, strengthening positioning and reputation." },
          ]
        )
      : detailPage(
          "POSICIONAMIENTO ESTRATÉGICO",
          "POSICIONAMIENTO ESTRATÉGICO<br />Y ESTRATEGIA DE GESTIÓN DE STAKEHOLDERS",
          [
            { h3: "Posicionamiento y diseño de narrativa institucional:", p: "Construimos mensajes claros y coherentes que refuercen la identidad corporativa y la percepción en el mercado." },
            { h3: "Identificación y gestión de stakeholders:", p: "Identificamos actores clave y desarrollamos estrategias para establecer relaciones sólidas y de confianza." },
            { h3: "Desarrollo de estudios de caso y comunicación estratégica orientada a objetivos:", p: "Elaboramos estudios de caso orientados a objetivos, fortaleciendo el posicionamiento y la reputación." },
          ]
        ),
  },
  "/otras-areas": {
    html: (locale) => locale === "en"
      ? detailPage(
          `<span class="detail-hero__title-main">OTHER AREAS OF ACTIVITY</span><br /><span class="detail-hero__title-secondary">TOURISM</span><br /><span class="detail-hero__title-secondary">URBAN PLANNING</span>`,
          "OTHER AREAS",
          [
            { h3: "Tourism", ul: ["Strategic development of tourist destinations", "Promotion and attraction of investment in the tourism sector", "Market analysis and diversification of the tourism offer", "Stakeholder management and collaborative models"] },
            { h3: "Sustainability and urban development", ul: ["Sustainability strategies for territories and businesses", "Circular economy and efficient resource management", "Climate change adaptation and urban resilience", "Participation, governance and multi-stakeholder partnerships"], spacers: 7 },
          ]
        )
      : detailPage(
          `<span class="detail-hero__title-main">OTRAS ÁREAS DE ACTIVIDAD</span><br /><span class="detail-hero__title-secondary">TURISMO</span><br /><span class="detail-hero__title-secondary">URBAN PLANNING</span>`,
          "OTRAS ÁREAS",
          [
            { h3: "Turismo", ul: ["Desarrollo estratégico de destinos turísticos", "Promoción y atracción de inversiones en el sector turístico", "Análisis de mercados y diversificación de la oferta turística", "Gestión de stakeholders y modelos colaborativos"] },
            { h3: "Sostenibilidad y urbanismo", ul: ["Estrategias de sostenibilidad para territorios y empresas", "Economía circular y gestión eficiente de recursos", "Adaptación al cambio climático y resiliencia urbana", "Participación, gobernanza y alianzas multiactor"], spacers: 7 },
          ]
        ),
  },
};

const ROUTE_RENDERERS = {
  "/": () =>     `
      <main class="home-hero">
        <video
          class="home-hero__bg"
          autoplay
          muted
          loop
          playsinline
          preload="metadata"
          aria-hidden="true"
        >
          <source src="${homeVideoUrl}" type="video/mp4" />
        </video>
        <div class="home-hero__overlay" aria-hidden="true"></div>
        <div class="home-hero__safe"></div>
      </main>
    `,
  ...Object.fromEntries(
    Object.entries(SERVICE_ROUTE_RENDERERS).map(([canonical, config]) => [canonical, config.html])
  ),
  "/equipo": (locale) =>     `
      <main>
        <section class="detail-hero">
          <div class="detail-hero__image" aria-hidden="true"></div>
          <div class="detail-hero__veil" aria-hidden="true"></div>
          <div class="detail-hero__content">
            <h1 class="detail-hero__title">${locale === "en" ? "OUR TEAM" : "EQUIPO"}</h1>
          </div>
        </section>

        <section class="detail-body team-detail-body">
          <div
            class="team-horizontal"
            data-team-horizontal
            tabindex="0"
            aria-label="${locale === "en" ? "Our Team horizontal scroll" : "Desplazamiento horizontal de Quiénes somos"}"
          >
            <div class="team-horizontal__track">
              <div class="team-horizontal__pane team-horizontal__pane--intro" aria-hidden="true"></div>
              <div class="team-horizontal__pane team-horizontal__pane--content">
                <article class="team-detail-panel" aria-label="${locale === "en" ? "Our Team" : "Quiénes somos"}" data-scroll-reveal>
                  <div class="team-detail-panel__content">
                    <div class="team-detail-panel__media">
                      <picture>
                        <source type="image/webp" srcset="${albertCastellanosWebpUrl}" />
                        <img
                          class="team-detail-panel__portrait"
                          src="${albertCastellanosUrl}"
                          alt="Albert Castellanos"
                          loading="lazy"
                        />
                      </picture>
                    </div>
                    <div class="team-detail-panel__copy">
                      <p class="team-detail-panel__text">
                        ${locale === "en"
                          ? `“Throughout my professional career, I have had the opportunity to assume senior responsibilities in public administration in the fields of economics and business —including serving as Secretary General for Economy and Secretary for Business and Competitiveness of the Government of Catalonia, and CEO of ACCIÓ— roles that have allowed me to acquire an in‑depth understanding of the economic landscape, innovation processes and institutional frameworks at both local and international levels, with a particular emphasis on Europe, shaped by my recent role as President of the Assembly of European Regions.
                        <br/><br/>
                          Today, as Director of Magallanes Business Consulting, I leverage this experience to advise companies and organizations that require vision, sound judgement and rigorous strategic guidance, combined with a close, direct and fully committed approach, to move forward with confidence in increasingly complex and demanding environments. With a clear purpose: sustainable growth amid constant change.”
                        <br/><br/>Albert Castellanos<br />Director`
                          : `“A lo largo de mi trayectoria he tenido la oportunidad de asumir responsabilidades de alto nivel en la gestión pública en los ámbitos de la economía y la empresa, entre ellas, secretario general de Economía, secretario de Empresa y Competitividad de la Generalitat de Catalunya y consejero delegado de ACCIÓ, lo que me ha permitido adquirir un conocimiento profundo del tejido económico, de los procesos de innovación y de los marcos institucionales a escala local e internacional, con un énfasis particular en el ámbito europeo gracias a mi reciente rol de presidente de la Asamblea Europea de las Regiones.
                        <br/><br/>
                          Hoy, como director de Magallanes Business Consulting, pongo esta experiencia al servicio de empresas y organizaciones que necesitan visión, criterio y un acompañamiento estratégico riguroso, pero también cercano, directo y plenamente implicado para avanzar con seguridad en entornos cada vez más cambiantes y exigentes. Con un claro propósito: crecer en un entorno complejo.”
                        <br/><br/>Albert Castellanos<br />Director`}
                      </p>
                      <picture>
                        <source type="image/webp" srcset="${signaturaWebpUrl}" />
                        <img
                          class="team-detail-panel__signature"
                          src="${signaturaUrl}"
                          alt="Firma"
                          loading="lazy"
                          decoding="async"
                        />
                      </picture>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>
    `,
  "/contacto": (locale) => {
    const legalLinks = locale === "en"
      ? [
          { canonical: "/aviso-legal", label: "legal notice" },
          { canonical: "/politica-de-privacidad", label: "privacy policy" },
          { canonical: "/politica-de-cookies", label: "cookie policy" },
        ]
      : [
          { canonical: "/aviso-legal", label: "aviso legal" },
          { canonical: "/politica-de-privacidad", label: "política de privacidad" },
          { canonical: "/politica-de-cookies", label: "política de cookies" },
        ];
    const legalNav = legalLinks
      .map((l) => `<a href="${withBase(localePath(locale, l.canonical))}">${l.label}</a>`)
      .join('<span aria-hidden="true"> - </span>');
    return `
        <main class="contact-page">
          <div class="contact-bg" style="--contact-bg-image: url('${backHomeUrl}'); --contact-bg-image-1440: url('${backHome1440Url}'); --contact-bg-image-1024: url('${backHome1024Url}'); --contact-bg-image-768: url('${backHome768Url}');"></div>
          <div class="contact-strip contact-strip--barcelona">
            <picture class="contact-strip__picture">
              <source media="(orientation: portrait)" srcset="${barcelonatxtUrl}" />
              <source type="image/webp" media="(max-width: 1024px)" srcset="${barcelona1024Url}" />
              <source type="image/webp" srcset="${barcelonaUrl}" />
              <img src="${barcelonaPngUrl}" alt="${locale === "en" ? "Barcelona Office" : "Oficina Barcelona"}" />
            </picture>
            <a class="contact-strip-link contact-strip-link--barcelona" href="tel:+34933637840" aria-label="${locale === "en" ? "Call Barcelona office" : "Llamar oficina de Barcelona"}"></a>
          </div>
          <div class="contact-strip contact-strip--madrid">
            <picture class="contact-strip__picture">
              <source media="(orientation: portrait)" srcset="${madridtxtUrl}" />
              <source type="image/webp" media="(max-width: 1024px)" srcset="${madrid1024Url}" />
              <source type="image/webp" srcset="${madridUrl}" />
              <img src="${madridPngUrl}" alt="${locale === "en" ? "Madrid Office" : "Oficina Madrid"}" />
            </picture>
            <a class="contact-strip-link contact-strip-link--madrid" href="tel:+34914170458" aria-label="${locale === "en" ? "Call Madrid office" : "Llamar oficina de Madrid"}"></a>
          </div>
          <div class="contact-visual">
            <img class="contact-visual__image" src="${bcnymdrUrl}" alt="" aria-hidden="true" />
            <svg
              class="contact-hotspots"
              viewBox="0 0 100 100"
              preserveAspectRatio="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <a class="contact-hotspots__link contact-hotspots__link--barcelona" href="tel:+34933637840" aria-label="${locale === "en" ? "Call Barcelona office" : "Llamar oficina de Barcelona"}">
                <rect class="contact-hotspots__hit" x="21" y="85" width="15" height="9" rx="0.2" />
              </a>
              <a class="contact-hotspots__link contact-hotspots__link--madrid" href="tel:+34914170458" aria-label="${locale === "en" ? "Call Madrid office" : "Llamar oficina de Madrid"}">
                <rect class="contact-hotspots__hit" x="46" y="8" width="14" height="10" rx="0.2" />
              </a>
            </svg>
          </div>

          <footer class="contact-footer">
            <div class="contact-footer__social">
              <a href="https://www.linkedin.com/company/magallanes-business-consulting" class="contact-footer__linkedin" target="_blank" rel="noopener" aria-label="LinkedIn">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a href="mailto:hola@magallanesbc.com" class="contact-footer__email">hola@magallanesbc.com</a>
            </div>
            <!--nav class="contact-footer__legal" aria-label="Legal">${legalNav}</nav-->
          </footer>
        </main>
      `;
  },
  "/aviso-legal": (locale) => legalPage(locale, {
    title: locale === "en" ? "Legal Notice" : "Aviso Legal",
    canonicalPath: "/aviso-legal",
    body: LEGAL_BODY_AVISO,
  }),
  "/politica-de-privacidad": (locale) => legalPage(locale, {
    title: locale === "en" ? "Privacy Policy" : "Política de Privacidad",
    canonicalPath: "/politica-de-privacidad",
    body: LEGAL_BODY_PRIVACIDAD,
  }),
  "/politica-de-cookies": (locale) => legalPage(locale, {
    title: locale === "en" ? "Cookie Policy" : "Política de Cookies",
    canonicalPath: "/politica-de-cookies",
    body: LEGAL_BODY_COOKIES,
  }),
};

const ROUTE_DEFS = ROUTE_CATALOG.map((route) => buildRouteDef(route, ROUTE_RENDERERS[route.canonical]));

function buildRoutes(defs) {
  const routes = [];
  for (const locale of LOCALES) {
    for (const def of defs) {
      const slugMap = CANONICAL_SLUGS[def.canonical];
      const slug = slugMap?.[locale] ?? "";
      const path = slug ? `/${locale}/${slug}/` : `/${locale}/`;
      const { title, ogDescription } = def.meta[locale];
      const body = typeof def.body === "function" ? def.body(locale) : def.body;
      routes.push({
        path,
        locale,
        routeCanonical: def.canonical,
        canonical: path,
        title,
        ogDescription,
        body,
        service: def.service ?? false,
        html: () => (def.html.length === 0 ? def.html() : def.html(locale)),
      });
    }
  }
  return routes;
}

const ROUTES = buildRoutes(ROUTE_DEFS);

function findRoute(pathname) {
  const normalized = normalizePath(pathname);
  return ROUTES.find((route) => normalizePath(route.path) === normalized) ?? null;
}

function applyEnteringState(route, { entering }) {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!entering || reduceMotion || !route?.service) {
    document.body.classList.remove("is-entering");
    return;
  }

  document.body.classList.add("is-entering");
  window.setTimeout(() => {
    document.body.classList.remove("is-entering");
  }, SERVICE_TITLE_DELAY_MS);
}

function hideTransitionLayerSoon() {
  const transitionLayer = document.querySelector(".page-transition");
  if (!transitionLayer) {
    return;
  }

  window.requestAnimationFrame(() => {
    window.setTimeout(() => {
      transitionLayer.classList.remove("is-active");
    }, TRANSITION_HIDE_DELAY_MS);
  });
}

function resetScrollPosition() {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
}

export function createSpaApp({ onAfterRender } = {}) {
  const render = (route, options = {}) => {
    if (!route) {
      return;
    }

    setBodyAttributes(route.body ?? { className: "page" });
    setDocumentMeta({
      title: route.title,
      canonicalPathname: route.canonical,
      ogTitle: route.title,
      ogDescription: route.ogDescription,
      locale: route.locale,
      routeCanonical: route.routeCanonical,
    });
    renderIntoApp(route.html());
    applyEnteringState(route, options);
    onAfterRender?.(route, options);
  };

  const navigate = (to, options = {}) => {
    const pathname = typeof to === "string" ? to : to?.pathname;
    const normalized = normalizePath(pathname);

    if (normalized === "/") {
      const localeHome = findRoute(`/${DEFAULT_LOCALE}/`);
      window.history.replaceState({}, "", withBase(`/${DEFAULT_LOCALE}/`));
      if (localeHome) {
        render(localeHome, { ...options, entering: false });
        hideTransitionLayerSoon();
      }
      return;
    }

    const route = findRoute(pathname);

    if (!route) {
      window.location.href = typeof to === "string" ? to : to?.toString?.() ?? "/";
      return;
    }

    const nextHref = withBase(route.path);
    window.history.pushState({}, "", nextHref);

    if (options.resetScroll !== false) {
      resetScrollPosition();
    }

    render(route, options);
    hideTransitionLayerSoon();
  };

  const start = () => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const normalized = normalizePath(window.location.pathname);
    if (normalized === "/") {
      navigate(`/${DEFAULT_LOCALE}/`, { entering: false });
    } else {
      const initial = findRoute(window.location.pathname);
      if (!initial) {
        navigate(`/${DEFAULT_LOCALE}/`, { entering: false });
        return;
      }
      render(initial, { entering: false });
    }

    let isTransitioning = false;

    document.addEventListener("click", (event) => {
      if (event.defaultPrevented) {
        return;
      }

      const target = event.target instanceof Element ? event.target.closest("a[href]") : null;
      if (!(target instanceof HTMLAnchorElement)) {
        return;
      }

      if (target.target && target.target !== "_self") {
        return;
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      const href = target.getAttribute("href");
      if (!href || href.startsWith("mailto:") || href.startsWith("tel:")) {
        return;
      }

      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) {
        return;
      }

      const hasTransition = target.dataset.transitionLink !== undefined;

      if (hasTransition && !isTransitioning) {
        event.preventDefault();
        isTransitioning = true;
        closeSiteMenu();
        runTransition(target, () => {
          isTransitioning = false;
          navigate(url, { entering: true });
        });
        return;
      }

      const isSpaRoute = Boolean(findRoute(url.pathname));
      if (!isSpaRoute) {
        return;
      }

      event.preventDefault();
      closeSiteMenu();
      navigate(url, { entering: false });
    });

    window.addEventListener("popstate", () => {
      const route = findRoute(window.location.pathname);
      if (route) {
        render(route, { entering: false, resetScroll: false });
        hideTransitionLayerSoon();
      }
    });
  };

  return { start, navigate };
}
